<template>
	<div>
		<Camera
			v-if="showCamera"
			@close-camera="closeCamera"
			@image-taken="(imageString) => loadImageAbastecimento(imageString)"
		/>
		<Camera
			v-if="showCameraAnexos"
			@close-camera="closeCameraAnexos"
			@image-taken="(imageString) => loadImageAnexos(imageString)"
		/>
		<AlertInfo v-if="campoOrigemCombustivelObrigatorio">
			<span> {{ _traducao('global', 'campoObrigatorioAbastecimento') }}. </span>
		</AlertInfo>
		<div v-for="(item, index) in form" :key="item.id">
			<div class="row" v-if="permitirExcluir">
				<div class="col-xs-12" style="margin: 0">
					<button
						class="btn btn-danger pull-right"
						@click="clickExcluirAbastecimento(item, index)"
						style="font-size: 14px"
						v-tooltip="_traducao('global', 'excluir')"
					>
						<i class="fa fa-fw fa-trash" />
					</button>
				</div>
			</div>
			<div class="row">
				<!-- COMBISTIVEL -->
				<div
					class="col-xs-12 col-sm-3 form-group"
					:class="{'has-error': item.erro.numero_ce != null}"
				>
					<label>* {{ _traducao('global', 'numeroDeCE') }}:</label>
					<input v-model="item.numero_ce" class="form-control" />
					<p class="help-block" v-if="item.erro.numero_ce != null">
						{{ item.erro.numero_ce }}
					</p>
				</div>
				<div
					class="col-xs-12 col-sm-3 form-group"
					:class="{'has-error': item.erro.volume != null}"
				>
					<label>* {{ _traducao('global', 'volume') }}:</label>
					<money
						v-model="item.volume"
						v-bind="_vpercem(1)"
						class="form-control text-right input-sm"
					/>
					<p class="help-block" v-if="item.erro.volume != null">
						{{ item.erro.volume }}
					</p>
				</div>
				<div
					class="col-xs-12 col-sm-3 form-group"
					:class="{'has-error': item.erro.origem_abastecimento != null}"
				>
					<label v-if="campoOrigemCombustivelObrigatorio"
						>* {{ _traducao('global', 'fornecedor') }}:</label
					>
					<label v-else> {{ _traducao('global', 'fornecedor') }}:</label>
					<div style="display: flex">
						<select class="form-control" v-model="item.id_fornecedor">
							<option
								v-for="fornecedor in fornecedores"
								:key="fornecedor.id"
								:value="fornecedor.id"
							>
								{{ fornecedor.razao_social }}
							</option>
						</select>
						<button
							type="button"
							class="btn btn-sm btn-info"
							@click="abrirCadastroFornecedor"
						>
							<i class="fa fa-plus fa-fw"></i>
						</button>
					</div>
					<p class="help-block" v-if="item.erro.origem_abastecimento != null">
						{{ item.erro.origem_abastecimento }}
					</p>
				</div>
				<div>
					<input-select
						class="col-xs-12 col-sm-3 form-group"
						:label="labelArmazenamento"
						:opcoes-objeto="unidadesArmazenamento"
						v-model="item.id_unidade_armazenamento"
						:mensagem-erro="item.erro.origem_abastecimento"
					/>
				</div>
			</div>

			<div class="row">
				<div
					class="col-sm-3 form-group"
					:class="{'has-error': item.erro.designativo_abastecimento != null}"
				>
					<label
						>{{ _traducao('global', 'aerodromoLocalAbastecimento') }}:</label
					>
					<select
						class="form-control"
						v-model="item.designativo_abastecimento"
						@change="
							alteraDataAbastecimento(item.designativo_abastecimento, index)
						"
					>
						<option value="origem">
							{{ _traducao('global', 'origem') }}
						</option>
						<option value="destino">
							{{ _traducao('global', 'destino') }}
						</option>
					</select>
					<p
						class="help-block"
						v-if="item.erro.designativo_abastecimento != null"
					>
						{{ item.erro.designativo_abastecimento }}
					</p>
				</div>
				<div
					class="col-sm-3 form-group"
					:class="{'has-error': item.erro.relacao_abastecimento != null}"
				>
					<label>{{ _traducao('global', 'relacao') }} Abastecimento :</label>
					<select
						class="form-control input-sm"
						v-model="item.relacao_abastecimento"
					>
						<option value="">
							{{ _traducao('global', 'escolha').toUpperCase() }}
						</option>
						<option value="%">%</option>
						<option value="Litros">
							{{ _traducao('global', 'litros') }}
						</option>
						<option value="Libras">
							{{ _traducao('global', 'libras') }}
						</option>
						<option value="Galão">
							{{ _traducao('global', 'galao') }}
						</option>
						<option value="Kg">Kg</option>
					</select>
					<p class="help-block" v-if="item.erro.relacao_abastecimento != null">
						{{ item.erro.relacao_abastecimento }}
					</p>
				</div>
				<div class="col-sm-6">
					<div class="" style="margin-top: 9px">
						<flUploadFile
							name="anexos"
							:id-input="index"
							:excluir-u-r-l="true"
							:excluir-adicionados="true"
							:excluir-por-id="true"
							:habilita-excluir="true"
							:url-excluir="urlExcluir"
							ref="anexos"
							@upload-file="(files) => uploadFiles(index, files)"
							:url="urlEnvio"
							ext="jpg|jpeg|png|pdf|doc|docx|xls|xlsx"
						></flUploadFile>
					</div>
				</div>
				<div v-if="_isMobile" class="col-sm-6">
					<ButtonNew size="lg" @click="openCamera(index)">Tirar Foto</ButtonNew>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12" style="margin-top: 10px">
				<button
					class="btn btn-info btn-sm"
					type="button"
					@click="clickAddAbastecimento()"
				>
					<i class="fa fa-fw fa-plus"></i
					>{{ _traducao('global', 'adicionarAbastecimento').toUpperCase() }}
				</button>
			</div>
		</div>
		<movimentacoes-combustivel
			ref="movimentacoesCombustivel"
			@selecionou-movimentacao="(data) => movimentacaoSelecionado(data)"
		/>
		<modalCadastroFornecedores ref="modalCadastroFornecedoresRef" />
	</div>
</template>

<script>
import Camera from '@/modules/componentsv2/camera/main.vue'
import mixinsAbastecimento from './mixinsAbastecimento.js'
import movimentacoesCombustivel from '../informacoes-movimentacoes-combustivel.vue'
import modalCadastroFornecedores from '../modal/cadastro-fornecedores.vue'
export default {
	name: 'ComponenteIntermediarioAbastecimento',
	mixins: [mixinsAbastecimento],
	components: {
		Camera,
		movimentacoesCombustivel,
		modalCadastroFornecedores
	},
	props: {
		dadosAbastecimento: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		aeronave: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		trecho: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		unidadesArmazenamento: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		fornecedores: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		permitirExcluir: {
			default: true,
			required: true,
			type: Boolean
		}
	},
	data() {
		return {
			form: [],
			abastecimentoIndex: 0,
			showCamera: false,
			showCameraAnexos: false,
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			urlExcluir: 'mg-siga/Relatorio_voo_trecho/excluir_anexo_abastecimento',
			urlExcluirAnexo: 'mg-siga/Relatorio_voo_trecho/excluir_anexo',
			campoOrigemCombustivelObrigatorio: false
		}
	},
	watch: {
		dadosAbastecimento: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.form = this.dadosAbastecimento
				}
			}
		}
	},
	methods: {
		async validadorFormAbastecimento() {
			if (await this.validarComponenteAbastecimento()) {
				this.$emit('abastecimento-valido', this.form)
			} else {
				this.$emit('abastecimento-invalido', false)
			}
		},
		atualizarListaFornecedores() {
			this.$emit('atualizar-lista-fornecedores')
		},

		async validarComponenteAbastecimento() {
			var passou = true
			var obrigatorio = this._traducao('global', 'obrigacao')

			const qtd_abastecimento = this.form.length
			for (
				let abastecimento = 0;
				abastecimento < qtd_abastecimento;
				abastecimento++
			) {
				if (this.form[abastecimento].numero_ce == null) {
					this.form[abastecimento].erro.numero_ce = obrigatorio
					passou = false
				} else {
					this.form[abastecimento].erro.numero_ce = null
				}
				if (this.form[abastecimento].volume <= 0) {
					this.form[abastecimento].erro.volume = obrigatorio
					passou = false
				} else {
					this.form[abastecimento].erro.volume = null
				}
				if (
					this.campoOrigemCombustivelObrigatorio &&
					this.form[abastecimento].id_fornecedor == null &&
					this.form[abastecimento].id_unidade_armazenamento == null
				) {
					this.form[abastecimento].erro.origem_abastecimento = this._traducao(
						'global',
						'peloMenosUmDeveSerObrigatorio'
					)
					passou = false
				} else {
					this.form[abastecimento].erro.origem_abastecimento = null
				}
			}

			return passou
		},

		carregaListaAnexo(anexosMovimentacao, index) {
			if (this.$refs.anexos) {
				this.$refs.anexos[index].carregaLista(anexosMovimentacao)
			}
		}
	},
	computed: {
		labelArmazenamento() {
			if (this.campoOrigemCombustivelObrigatorio) {
				return '* ' + this._traducao('global', 'unidadeDeArmazenamentoDeOrigem')
			}
			return this._traducao('global', 'unidadeDeArmazenamentoDeOrigem')
		}
	},
	created() {
		this._getParametro(181).then(
			(valor) => (this.campoOrigemCombustivelObrigatorio = Number(valor) == 1)
		)
	}
}
</script>

<style scoped></style>